import styled, { css } from 'styled-components';
import background from '../../../assets/images/background.png'

export const Container = styled.div`
    width: 100vw;
    background-color: #000;
    color: #fff;
`

export const StyledRow = styled.div`
    background-color: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 10em;
    background-image: url(${background});
    
    h1 {
        text-align: center;
        margin: 2em 0 .5em 0;
        font: italic bold 42px "Roboto Condensed";
        width: 80%;
        text-transform: uppercase;

        span {
            color: #ff0033;
        }
    }
    h2 {
        font-size: 24px;
        width: 70%;
        color: #3ee9f7;
        font-style: italic;
        font-weight: 400;
        margin: 0 0 1em 0;
        text-align: center;
    }

    p.checkout-more { 
        font: normal italic 18px 'Roboto Condensed';
        
        span {color: #3ee9f7;}
    }
`

export const VideoContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 60%
    align-items: center;
    justify-content: space-between;
    border: 1px solid #4a4a4a;
    ${props => props.borderColor && css`
        border-left: ${props.borderColor} 3px solid
    `};
    margin: 2em 0;
    

    div.descript-wrapper {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 1.5em;
        justify-content: flex-start;
        align-items: flex-start;

        h3 {
            font: normal bold 32px "Roboto Condensed";
        }
        p {
            font: italic normal 20px "Roboto Condensed";
            // color: #3ee9f7;
            text-align: left;
        }
    }
    div.vid-wrapper {
        width: 60%;
    }
`



// WEBPACK FOOTER //
// ./src/pages/Onboard/PostPayment/PostPayment.styles.ts